import { ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6149d6c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "device-id-input-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "rgba(0, 0, 0, 0.45)",
    "font-size": "12px",
    "margin-top": "2px"
  }
}, "批量赠送时一行一个", -1));
import { addGivenGift, retryGivenGift } from '@/api/givenGift';
import { awaitWrap, filterOption, OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'PropsAddModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    dbtId: null,
    editItem: null
  },
  emits: ['update:modalVisible', 'submitGiven', 'updateList', 'resetEdit'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const rules = {
      deviceId: [{
        required: true,
        message: '请输入用户设备ID',
        trigger: 'blur'
      }],
      prodId: [{
        required: true,
        message: '请输入赠送内容',
        trigger: 'blur'
      }],
      price: [{
        required: true,
        message: '请输入商品价格',
        trigger: 'blur'
      }],
      prodNum: [{
        required: true,
        message: '请输入商品数量',
        trigger: 'blur'
      }],
      reason: [{
        required: true,
        message: '请输入赠送理由',
        trigger: 'blur'
      }]
    };
    const givenForm = ref({
      deviceId: '',
      prodId: '',
      price: null,
      reason: '',
      prodNum: 1
    });
    const givenRef = ref(null);
    const productList = ref([]);
    const loading = ref(false); // loading状态
    const isExpanded = ref(false); // 控制设备ID输入框是否展开
    // 切换展开/收起状态
    const toggleExpand = () => {
      isExpanded.value = !isExpanded.value;
    };
    const closeModal = () => {
      var _givenRef$value;
      givenForm.value = {
        deviceId: '',
        prodId: '',
        price: null,
        prodNum: 1,
        reason: ''
      };
      (_givenRef$value = givenRef.value) === null || _givenRef$value === void 0 || _givenRef$value.resetFields();
      isExpanded.value = false;
      emit('update:modalVisible', false);
      emit('resetEdit');
    };
    const submitGiven = () => {
      givenRef.value.validate().then(async () => {
        const deviceIds = givenForm.value.deviceId.split(/\r?\n/).filter(id => id.trim());
        // 如果没有设备ID，就不提交
        if (!deviceIds.length) {
          message.error('请输入至少一个设备ID');
          return;
        }
        loading.value = true;
        // 使用批量接口处理所有情况
        const params = {
          prodId: givenForm.value.prodId,
          deviceIdList: deviceIds.map(id => id.trim()),
          prodNum: givenForm.value.prodNum || 1,
          giftReason: String(givenForm.value.reason),
          dbtId: props.dbtId
        };
        // 如果是重试场景，添加id参数
        if (givenForm.value.id) {
          params.id = givenForm.value.id;
        }
        const [err, data] = await awaitWrap(givenForm.value.id ? retryGivenGift(params) : addGivenGift(params));
        if (data && data.code === OK) {
          const {
            successCount = 0,
            failCount = 0
          } = data.data || {};
          if (successCount > 0 || !data.data) {
            // 兼容没有返回data.data的情况
            let successMessage = '操作成功';
            if (data.data) {
              successMessage = `成功赠送 ${successCount} 条记录${failCount > 0 ? `，失败 ${failCount} 条` : ''}`;
            }
            message.success(successMessage);
            emit('updateList');
            closeModal();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '道具赠送',
                element_name: '赠送道具'
              }
            });
          } else if (failCount > 0) {
            message.error(`赠送失败，请稍后重试`);
          }
        } else {}
        loading.value = false;
      });
    };
    const changeProd = () => {
      const item = productList.value.find(item => item.value === givenForm.value.prodId) || {
        prodPrice: 0
      };
      if (item) {
        givenForm.value.price = item.prodPrice;
      }
    };
    /*watch(
        () => props.modalVisible,
        (val) => {
          if (val) {
            getProductList()
          }
        },
        {
          immediate: true,
        },
      )*/
    watch(() => props.editItem, n => {
      var _Object$keys;
      if (n && (_Object$keys = Object.keys(n)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
        givenForm.value = {
          ...n
        };
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        class: "given-modal",
        title: "赠送道具",
        centered: "",
        open: __props.modalVisible,
        onCancel: closeModal,
        onOk: submitGiven,
        "confirm-loading": loading.value,
        "ok-text": "赠送",
        width: "540px"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "propsForm",
          model: givenForm.value,
          ref_key: "givenRef",
          ref: givenRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "设备ID",
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 20
            },
            name: "deviceId",
            required: ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_textarea, {
              value: givenForm.value.deviceId,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => givenForm.value.deviceId = $event),
              placeholder: "请输入用户设备ID",
              disabled: !!givenForm.value.id,
              "auto-size": {
                minRows: isExpanded.value ? 5 : 1,
                maxRows: isExpanded.value ? 10 : 1
              }
            }, null, 8, ["value", "disabled", "auto-size"]), _createVNode(_component_a_button, {
              type: "link",
              onClick: toggleExpand,
              class: "expand-button"
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                "icon-class": isExpanded.value ? 'close_arrow' : 'open'
              }, null, 8, ["icon-class"])]),
              _: 1
            }), _hoisted_2])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "赠送内容",
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 20
            },
            name: "prodId",
            required: ""
          }, {
            default: _withCtx(() => [!productList.value.length ? (_openBlock(), _createBlock(_component_a_input, {
              key: 0,
              value: givenForm.value.prodId,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => givenForm.value.prodId = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "请输入赠送内容"
            }, null, 8, ["value"])) : (_openBlock(), _createBlock(_component_a_select, {
              key: 1,
              "show-search": "",
              value: givenForm.value.prodId,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => givenForm.value.prodId = $event),
              placeholder: "请选择内购ID",
              options: productList.value,
              onChange: changeProd,
              "filter-option": _unref(filterOption)
            }, null, 8, ["value", "options", "filter-option"]))]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "赠送数量",
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 20
            },
            name: "prodNum",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              precision: 0,
              value: givenForm.value.prodNum,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => givenForm.value.prodNum = $event),
              placeholder: "请输入赠送数量",
              min: 1
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "赠送理由",
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 20
            },
            name: "reason",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: givenForm.value.reason,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => givenForm.value.reason = $event),
              placeholder: "请输入赠送理由",
              maxlength: 50
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});